import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { loadGrammarLessonCards } from '../../services/grammarV2';
import LessonFlow from '../../components/LessonFlow';

// Grammar's interactive lesson cards reuse the same LessonFlow shell
// topic-lessons uses — grammar just has no per-lesson "level" or
// sibling-chapter catalog the way topic-lessons does, so there's no
// TopicProgressService write on completion, just the finish screen.
export default function GrammarLessonPage() {
  const { t } = useTranslation();
  const { lessonId } = useParams();
  const { languagePrefs } = useAuth();
  const targetCode = languagePrefs?.targetLanguage || '';

  const loader = useCallback(
    () => loadGrammarLessonCards(targetCode, lessonId),
    [targetCode, lessonId],
  );

  return (
    <LessonFlow
      loader={loader}
      loaderDeps={[targetCode, lessonId]}
      backTo="/learn/grammar"
      backLabel={t('grammar.title')}
    />
  );
}
